import { sfx } from '../services/audioSynthesis';

class AudioMixController {
  private enabled: boolean = true;

  constructor() {
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem('pro_audio_enabled');
      this.enabled = saved !== 'false';
    }
  }

  public initCtx() {
    sfx.unlockAudio();
  }

  async preload(_urls: string[]) {}

  setEnabled(enabled: boolean) {
    this.enabled = enabled;
  }

  isEnabled() {
    return this.enabled;
  }

  public playPop(_force: boolean = false) {
    if (this.enabled || _force) {
      sfx.playUiClick();
    }
  }
  public playSave(_force: boolean = false) {
    if (this.enabled || _force) {
      sfx.playUiClick();
    }
  }
  public playSuccess(_force: boolean = false) {
    if (this.enabled || _force) {
      sfx.playUiClick();
    }
  }
  public playFoodSuccess(_force: boolean = false) {
    if (this.enabled || _force) {
      sfx.playUiClick();
    }
  }
  public playWaterLogged(_force: boolean = false) {
    if (this.enabled || _force) {
      sfx.playUiClick();
    }
  }
  public playInsightUnlocked(_force: boolean = false) {
    if (this.enabled || _force) {
      sfx.playUiClick();
    }
  }
  public playConfetti(_force: boolean = false) {
    if (this.enabled || _force) {
      sfx.playUiClick();
    }
  }
  public playScan(_force: boolean = false) {
    if (this.enabled || _force) {
      sfx.playUiClick();
    }
  }
  public playGeiger(_force: boolean = false) {}
  public playCyber(_force: boolean = false) {}
  public playFanfare(_force: boolean = false) {}
  public playStalkerLog() {
    if (this.enabled) {
      sfx.playUiClick();
    }
  }
}

export const sounds = new AudioMixController();

